module.exports = __webpack_public_path__ + "img/imagen1.d2be1359.png";